<template>
    <div class="flex flex-col text-center">
        <span class="icon">
            <i class="fas fa-spinner fa-spin fa-1x" :style="style"></i>
        </span>
    </div>
</template>

<script>
export default {
    props : {
        isLoading: {},
        settings:{},
        size: {
            default : "24px",
            type: String,
        },
    },
    inject: [],
    data() {
        return {

        }
    },
    computed: {
        style(){
            return "font-size:" + this.size + ";";
        }
    },
    methods: {

    },
}
</script>
<style scoped>

</style>
